import BossModel from "@/models/BossModel";
import MarketingChannel from "@/models/Customer/MarketingChannel/MarketingChannel";

export default class PersonalDetail extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-offer/personal-detail';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteOfferPersonalDetails';

    static fields() {
        return {
            id: this.attr(null),
            tradetracker: this.attr(null),
            website_country: this.attr(null),
            adults: this.attr(null),
            children: this.attr(null),
            babies: this.attr(null),
            gender_cid: this.attr(null),
            firstname: this.attr(null),
            lastname: this.attr(null),
            phone_number: this.attr(null),
            email: this.attr(null),
            customer_marketing_channel_id: this.attr(null),
            newsletter: this.attr(null),
            comments: this.attr(null),
            'marketingChannel': this.belongsTo(MarketingChannel, 'customer_marketing_channel_id'),
        }
    }

    MarketingChannel() {
        return this.getRelated('marketingChannel');
    }
}
